import 'css-chunksrc/feature/check-item/CheckItemScheduleModal.module.scss';export default {
  "form": "CheckItemScheduleModal_form",
  "switch-wrapper": "CheckItemScheduleModal_switch-wrapper",
  "switch": "CheckItemScheduleModal_switch",
  "wrapper": "CheckItemScheduleModal_wrapper"
};